let content = [
    {
      id: "general_trading_conditions",
      title: "General trading Conditions",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "Product Details",
          content_before: `<p class="mb-5">
                          iFOREX Europe offers highly competitive conditions for the following financial instruments (“Financial Instruments” or “Instruments”) (i) leveraged margin trading of financial instruments /underlying assets (“Underlying Assets”) including Currency pair (Forex), Commodity, Index, Share, ETF and Crypto based on CFDs (“Leveraged Instruments” or “CFDs”).
                          <br><br>
                          <b>Spreads</b><br>The cost of opening a deal is called the 'spread'. It is the difference between the Sell (Bid) price and the Buy (Ask) price. For example, if the USD/JPY is trading at a sell price of 101.202 and a buy price of 101.222, the difference between these two prices is called the spread. In this case the spread is 2 pips. Should you decide to close a deal immediately after opening it - and before any price movement occurs - the spread amount will be deducted from your balance.
                          <br><br>
                          <b>Margin and Leverage</b><br>While the "Margin" acts as collateral to cover any losses that you might incur, it also allows you to hold a position much larger than your actual account value, giving you the possibility to generate large profits relative to the amount invested.
                          <br><br>
                          Leverage is a double-edged sword and can dramatically amplify your profits, however it can also just as easily amplify your losses. When you use excessive leverage, losing trades can quickly offset many winning trades. Leveraged trading carries a high degree of risk and may not be suitable for all investors.
                          <br><br>
                          As an iFOREX Europe account holder, you’re entitled to our Negative Balance Protection program, which means that you can never lose more than you deposited; nonetheless, a small market movement can result in a substantial loss of funds. Our Trading Platform automatically calculates your margin requirements before executing any order, and checks the level of available funds before any request to withdraw funds is made.
                          <br><br>
                          The margin requirements are relevant upon increasing Exposure in the account, either by opening/closing deals or by requesting to withdraw funds while having open positions in the account.
                          </p>
                            <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/trading-conditions/currencies">Currencies</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/commodities">Commodities</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/indices">Indices</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/shares">Shares</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/etfs">ETFs</a></p>
                            <p class="tc-inner-link"><a href="/trading-conditions/crypto">Crypto</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "Trading Hours",
          content_before: `<p>
          During the European and North American winter, the weekly activity begins on Sunday at 22:05 GMT continuously until Friday, 21:00 GMT. During the Day Light Saving times in these regions, the weekly market activity begins on Sunday at 21:05 GMT and ends on Friday at 20:00. Market activity hours may vary due to public holidays or due to unusual liquidity conditions which may arise from exceptional global events. Opening or Closing times may also be altered by iFOREX Europe due to liquidity and risk management considerations.
              <br><br>
              Although most of the instruments are traded on a 24 hour basis without interruption, some instruments, however, have special trading hours as seen in the table below:
              </p>`,
  
          data_id: "TradingHours",
          products: {
            1:"Currencies & Crypto",
            2:"Commodities",
            3:"Indices",
            4:"Shares",
            5:"Precious Metals Spot",
            8:"ETFs"
          },
          table_titles: [
            "Market",
            "Trading Hours (GMT)",
            "1st Daily Break Time (GMT)",
            "2nd Daily Break Time (GMT)",
            "Data Valid Until (GMT)"
          ],
          content_after: `<p>Not sure which Market includes the instrument you're looking for? Click <span class="tclink" target-tab="tc-view-6">here</span> to view the full list of instrument per Market.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "Holidays",
          content_before: `<p>
          To ensure that you are aware of all market hours and holidays please find below a list of events which could change trading hours.<br>
              At iFOREX Europe we do our utmost to keep this information up-to-date on a best efforts basis.<br>
              Should you wish to receive more information please feel free to contact our dealing desk.
              </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "Market",
            "Trading Halt at (GMT)",
            "Trading Resume at (GMT)",
          ],
          content_after: `<p class="mt-4">Not sure which Market includes the instrument you're looking for? Click <span class="tclink" target-tab="tc-view-6">here</span> to view the full list of instrument per Market.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "Orders and execution",
          content_before: `<p><b>Order Types</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>MARKET ORDERS</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Open Deal</td>
                   <td>An order to open a position at the current available market rate</td>
                </tr>
                <tr>
                   <td>Close Deal</td>
                   <td>An order to close a position at the current available market rate</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>LIMIT ORDERS</th>
                   <th></th>
                </tr>
                <tr>
                   <td>Stop Loss</td>
                   <td>The Stop Loss is an order to open or close a deal at a rate inferior to the current market rate</td>
                </tr>
                <tr>
                   <td>Take Profit</td>
                   <td>The Take Profit is an order to open or close a deal at a rate superior to the current market rate</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>Market Orders</b><br>Market Orders (trade requests, i.e. Open Deal, Close Deal) are executed at the price that is in effect on the Company’s Trading Platform (client side) at the exact time of execution, provided that such price is within a predetermined tolerance level from the underlying price updated in the Company’s servers and irrespective if the underlying price is above or below the price updated in the Trading Platform (What You See Is What You Get, or WYSIWYG). In the event that the price updated in the trading platform (client side) exceeds the above tolerance level, for example, due to movements in the underlying assets between the time a client placed its order and the time it is received and executed, high markets volatility and communication latency, the Order will be executed at the price updated in the Company’s servers which shall be different from the price updated in the Trading Platform (Market Price), on a symmetrical basis. In the event of a substantial difference between the price updated in the Trading Platform (client side) and the price updated in the Company’s servers, the Order shall be rejected.
          </p>
          <p>
             <b>Limit Orders</b><br>Limit Orders (future orders) are executed at the market price updated at the Company’s servers which may be different than the price indicated in the Order ("Slippage"). Slippage may occur in the event where the price indicated in the order is not available in the servers, for example, due to high volatility and gaps in the market prices. In such event, the order will be executed at the first available price, irrespective of the direction of the slippage, either to the client’s favor or not, in a symmetrical and transparent manner (Symmetrical Slippage).<br><br>Instruments (e.g. shares and indices) which are not traded on a 24 hours basis, may experience a market gap on a daily basis and are therefore more susceptible to slippage. It is important to note that Slippage does not affect the Negative Balance Protection and therefore the Client will never lose more than the amount invested (including any profit, if gained), even if a slippage occurs.<br><br>Please note: Should the client have set a Limit Order on their open deal/s, some or all of these deal/s may be closed automatically before reaching their respective Limit Orders, due to the mandatory auto Close-out Protection mechanism. For further information on mandatory Margin Close-Out Protection, please review the "Margin Information" tab below.
          </p>
          <p>
             <b>Delays in Execution</b><br>A delay in execution may occur for various reasons, such as technical issues with the Client’s internet, mobile or other communication connection to the iFOREX Europe servers, which may result in "hanging orders". A disturbance in the connection path can sometimes interrupt the signal and disable the platform causing delays in transmission of data between the trader’s platform and the iFOREX Europe server.
          </p>
          <p>
             <b>Hanging Orders</b><br>During periods of heavy trade volume or communication latency, hanging orders may occur, which means that a Limit Order has been placed, but it is simply taking a few moments for it to be confirmed/processed. During periods of heavy trading volumes or communication latency, it is possible that a queue of Limit Orders will form. That increase in incoming orders may sometimes create conditions where there is a delay in confirming/processing certain Limit Orders. In some cases, the position may in fact have been executed and the delay is simply in the client’s side display due to heavy internet traffic.<br><br>Keep in mind that it is only necessary to enter any order once. Multiple entries for the same order may slow or lock your computer or inadvertently open unwanted positions.
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "Negative Balance Protection",
          content_before: `<p>
                            iFOREX Europe's Negative Balance Protection policy guarantees that the client’s losses are limited to the funds invested in the client’s account. According to this policy, the client shall never have to face a debit balance due to trade losses when trading with iFOREX Europe and client’s potential loss shall be limited to the funds deposited in the Client’s account and to the funds gained by the client, if any.
                            </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "margin_information",
          id:'tc-view-24',
          title: "Margin Information",
          content_before: `
                      <p>
                      The window displayed below provides detailed information related to the margin of an account:
                      <div class="table-wrapper">
                         <table class="table3 mt-4 mb-4">
                            <tbody>
                               <tr>
                                  <td>Used Margin</td>
                                  <td style="">2,500</td>
                               </tr>
                               <tr>
                                  <td>Available Margin</td>
                                  <td style="">$2,495</td>
                               </tr>
                               <tr>
                                  <td>Margin Utilization</td>
                                  <td style="color:green">50.05%</td>
                               </tr>
                               <tr>
                                  <td>Maintenance Margin</td>
                                  <td style="">$1,250</td>
                               </tr>
                               <tr>
                                  <td>Exposure Coverage</td>
                                  <td>0.50%</td>
                               </tr>
                            </tbody>
                         </table>
                      </div>
                      <ul class="list-style-disc-small mb-3">
                         <li><b>Used Margin</b> shows the amount of Equity in an account that is currently being used as Margin for your Open Deals. In the case where Used Margin is equal to or larger than the Equity, this indicates that the account's leverage is Maximized. During and around trading breaks, the Required Margin of some instruments (as detailed in the ‘Product Details table’) increases - and this affects the Available Margin, which might be dramatically reduced during the weekend as a result.<br>Used Margin = Net Exposure in an Instrument x The Required Margin for that Instrument</li>
                         <li><b>Available Margin</b> shows the amount of equity in an account that is not currently being used and is available for further increase of net exposure. In the case where Available Margin is zero, this indicates maximum leverage usage in the account.<br>Available Margin = Equity – Used Margin</li>
                         <li><b>Margin Utilization</b> shows the percentage of Equity that is being used as Margin for the currently Open Deals of the account. 100% Margin Utilization and above, indicates maximum leverage usage in the account.<br>Margin Utilization % = (Used Margin/Equity) x 100</li>
                         <li><b>Maintenance Margin</b> reflects 50% of the Used Margin required to maintain Open Deals in the account. When the Equity of an account falls to a level equal to or below the Maintenance Margin, the Company will auto close the highest consuming Used Margin deal or all Open Deals under a specific instrument.<br>Maintenance Margin = Used Margin x 0.5</li>
                         <li><b>Exposure Coverage</b> reflects the maximum change in market price against the direction of your open deals, which is supported by funds in your account.<br>Exposure Coverage = (Equity – Maintenance Margin) / Net Exposure</li>
                      </ul>
                      <b>Margin Close-out Protection</b><br>Should the funds available in a client’s Equity be equal to or fall below the Maintenance Margin, iFOREX Europe will auto close the deal that consumes the largest amount of Used Margin in order to achieve the lowest possible Maintenance Margin (closing only Open Deals on instruments that are open at that time in accordance with the published trading hours). Should there be no Open Deals on instruments that are open at that moment, the Open Deal on the instrument that first receives a quote will be auto closed first. Where there are multiple deals (more than one) that consume the largest amount of Used Margin equally, the Company will auto close the deal that was opened first. In the event that the lowest possible Maintenance Margin cannot be achieved by the auto closing of a single deal, the Company will auto close all Open Deals under a specific instrument. iFOREX Europe allows clients the full use of unrealized profits from their Open Deals, in order to support their losing deals.
                      <br><br>
                      <b><u><u>Examples</u></u></b><br><br>
                      <b>Example I</b><br>
                      This example involves a situation where a client holds multiple deals open and the account Equity reaches a level equal to or below the Maintenance Margin:<br><br>
                      <ul class="list-style-disc-small mb-3">
                         <li>Open Deals:</li>
                         <ul class="list-style-disc-small empty-disc ml-4">
                            <li>1 EUR/USD deal: BUY €60,000 @ rate 1.1750 (Initial Used Margin Required = 3.33% x €60,000 = €1,998)</li>
                            <li>1 Germany 40 deal: BUY 4 contracts @ rate 12,500 (Initial Used Margin Required = 5% x 4 x €12,500 = €2,500)</li>
                            <li>1 WTI Oil deal: BUY 500 barrels @ rate 70.00 or 59.56 a barrel when value is in Euro (Initial Used Margin Required = 10% x 500 x €59.56 = €2,978)</li>
                         </ul>
                         <li>Used Margin = €1,998 + €2,500 + €2,978 = €7,476</li>
                         <li>Margin Maintenance Level = €3,738</li>
                      </ul>
                      As soon as the account’s Equity reaches a level equal to or below €3,738, the Margin Close-out Protection will be triggered by closing the deal consuming the highest Used Margin, which is the <b>BUY 500 barrels of WTI Oil</b>.<br><br>
                      <b>Example II</b><br>
                      This example involves a situation where a client holds multiple deals open and the account Equity reaches a level equal to or below the Maintenance Margin:<br><br>
                      <ul class="list-style-disc-small mb-3">
                         <li>Open Deals:</li>
                         <ul class="list-style-disc-small empty-disc ml-4">
                            <li>2 USD/JPY deals: BUY $100,000 (Initial Used Margin Required = 3.33% x $100,000 = $3,330), SELL 80,000 (Initial Used Margin Required = 3.33% x $80,000 = $2,664)</li>
                            <li>1 USD/TRY deal: SELL $80,000 (Initial Used Margin Required = 5% x $80,000 = $4,000)</li>
                         </ul>
                         <li>Used Margin = ($3,330 – $2,664) + $4,000 = $4,666</li>
                         <li>Margin Maintenance Level = $2,333</li>
                      </ul>
                      As soon as the account Equity reaches a level equal to or below $2,333, the Margin Close-out Protection will be triggered by closing the deal consuming the highest Used Margin which is the <b>SELL $80,000 USD/TRY</b>.<br><br>Please note that:<br><br>
                      <ul class="list-style-disc-small mb-3">
                         <li>Closing the $80,000 SELL USD/JPY would increase the Net Exposure on USD/JPY from $20,000 to $100,000, thus the <b>Used Margin would increase by $2,664 ⇾</b> ($100,000 x 3.33%) - (20,000 x 3.33%) = $3,330 - $666 = <u>+$2,664</u></li>
                         <li>Closing the $100,000 BUY USD/JPY would increase the Net Exposure on USD/JPY from $20,000 to $80,000, thus the <b>Used Margin would increase by $1,998 ⇾ </b>$(80,000 x 3.33%) – ($20,000 x 3.33%) = $2,664 - $666 = <u>+$1,998</u></li>
                         <li>Closing the $80,000 SELL USD/TRY would decrease the Net Exposure on USD/TRY from $80,000 to 0, thus the <b>Used Margin would decrease by $4,000</b></li>
                      </ul>
                      <b>Example III</b><br>
                      This example involves a situation where a client holds multiple Open Deals, however the lowest possible Maintenance Margin cannot be achieved by auto closing a single deal:<br><br>
                      <ul class="list-style-disc-small mb-3">
                         <li>Open Deals:</li>
                         <ul class="list-style-disc-small empty-disc ml-4">
                            <li>3 USD/JPY deals: BUY $100,000 (Initial Used Margin Required = 3.33% x $100,000 = $3,330), SELL $70,000 (Initial Used Margin Required = 3.33% x $70,000 = $2,331), SELL $10,000 (Initial Used Margin Required = 3.33% x $10,000 = $333).</li>
                            <li>2 USD/TRY deal: SELL $10,000 (Initial Used Margin Required = 5% x $10,000 = $500), Buy $8,000 (Initial Used Margin Required = 5% x $8,000 = $400)</li>
                            <li>2 USD/RUB deal: SELL $10,000 (Initial Used Margin Required = 5% x $10,000 = $500), Buy $7,000 (Initial Used Margin Required = 5% x $7,000 = $350)</li>
                         </ul>
                         <li>Used Margin = ($3,330 – $2,331 – $333) + ($500 - $400) + ($500 - $350) = $916</li>
                         <li>Margin Maintenance Level = $458</li>
                      </ul>
                      In this case, as soon as the Equity reaches a level equal to or below $458, deals in the account will be auto closed on an instrument level, based on the instrument with the highest Net Exposure. Therefore, <b>all USD/JPY deals</b> will be closed.<br><br>Please note that:<br><br>
                      <ul class="list-style-disc-small mb-3">
                         <li>Closing any of the deals would increase the Net Exposure, hence the <b>Used Margin would increase</b>.</li>
                         <li>Closing all USD/JPY deals will reduce Net Exposure by $20,000, <b>thus the Used Margin would decrease by $666</b>, which is greater than closing USD/TRY deals, which will decrease Used Margin by $100, or USD/RUB deals, which will decrease Used Margin by $150.</li>
                      </ul>
                      </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "Additional Trading Rules",
          content_before: `
              <p>
              <b>Maximum Exposure</b><br>
              As a prudential measure aimed at better risk management and avoidance of excessive exposure to a single client, iFOREX Europe has set a maximum net exposure limitation of up to 12 (twelve) million Euro per client. iFOREX Europe had also set a maximum net exposure per instrument. To view the maximum exposure per instrument <span class="tclink" target-tab="tc-view-6" target-section="product_section">click here</span>. iFOREX Europe has the right, at its sole discretion to cancel or change such a limitation at any given moment without any prior notice.
              <br><br>
              <b>Hedging</b><br>
              Hedging is defined as the opening of two Transactions on the same instrument or underlying asset at different directions (one "buy" and the other "sell"), whether or not at the same time and whether or not for the same quantity. iFOREX Europe considers hedging transactions for the purpose of calculating the minimum margin on a cumulative basis or on a "net" basis. Furthermore, iFOREX Europe considers the closing of one of the hedged Transactions as the opening of a new Transaction which amount’s equals to the amount of the remaining Transaction.
              <br><br>
              <b>Netting of Transactions</b><br>
              In the case where more than one deal needs to close simultaneously in an account, iFOREX Europe will close all open positions as a bulk.<br>The transaction number assigned on each closed position is set based on FIFO rules. This means that upon the closing of the positions, the first position opened will receive the lowest transaction number and the last position opened will receive the highest transaction number.
              <br><br>
              <b>Unauthorized Trading Practices</b><br>
              iFOREX Europe supports fair trading and does not allow practices which exercise abusive trading such as lag trading, price manipulation, time manipulation or any other practices which are illegal and/or are utilized to give the Client an unfair advantage. Examples for such forbidden practices can be, but not limited to, any of the following:
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>Scalping</b> is a trading strategy that attempts to exploit small changes in prices. Traders who implement this strategy will create many short-term positions, usually closing them within seconds or minutes.
                 </li>
                 <li>
                    <b>Automation</b> (e.g. EAs) or algorithmic trading is the use of electronic platforms for entering trading orders with an algorithm which executes pre-programmed trading instructions whose variables may include timing, price, or quantity of the order, or in many cases initiating the order by a "robot", without human intervention.
                 </li>
                 <li>
                    <b>API trading</b> is an application programming interface refers to all trading that uses a software program to interact with other programs. The API acts as the middleman between the trader and the market, relaying orders and retrieving information as needed.
                 </li>
                 <li>
                    <b>Multiple accounts</b> is the term referring to two or more accounts set up by one client in order to get multiple incorrectly the account related benefits provided by iFOREX Europe.
                 </li>
              </ul>
              <p>Where the Company has any indication or suspicion, at its sole and absolute discretion, of any form of an exploitation, illegal, unfair, unauthorized and/or abusive trading practices, utilized to give the Client an unfair advantage, and/or of fraud, manipulation or breach of the Company’s agreements, policies, terms and conditions, the Company shall have the right, at its sole and absolute discretion, and without derogating from its rights under its agreements with the client and applicable law, to nullify and cancel all transactions carried in relevant accounts, including all profits or losses generated therein and/or block the account.</p>
              <b>Errors in Rates</b><br>
              Online trading technology is not perfect and in rare cases, the feed can be disrupted. This may only last for a moment, but when it does, prices can often become affected. While it may be tempting to place an "arbitrage transaction", keep in mind that in such situations, the prices do not reflect the true market price and your actual fill may be many pips away from the displayed price. In the event that trades are executed at prices not actually offered by iFOREX Europe, iFOREX Europe reserves the right to reverse such trades as they are not considered valid trades. Keep in mind that these instances are usually rare, and by not trading during these moments, traders can avoid the risk associated with the above scenarios.
              <br><br>
              <b>Maintenance Fee</b><br>
              Clients’ accounts in which there have been no trading activity for a period of twelve (12) consecutive months will be charged with a quarterly maintenance fee of US$15 or the account’s entire Equity if the Equity is less than US$15.<br>If the client does not have any available funds in its account iFOREX Europe will not charge maintenance fee.
              <br><br>
              For more information about trading, see our <a href="/legal/client-agreement.pdf">Terms and Conditions</a><a href="" target="_blank" rel="noopener"></a>.
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "Forex",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "Overnight Financing",
          content_before: `
                  <p>
                      When trading leveraged Forex CFDs with iFOREX Europe, your open deals are subject to Overnight Financing at the end of each trading day. This Overnight Financing may be subject to credit or debit, calculated on the basis of the relevant interest rates for the currencies in which the underlying instrument is traded, plus a mark-up. The mark-up for currency pairs starts at 0.75% and can be higher as well as differ between Long (Buy) and Short (Sell) positions. Please review the below table for the latest Overnight Financing levels.
                      <br><br>
                      If the calculated Overnight Financing Percentage is positive, it means that an applicable amount will be added (credited) to your account balance. A negative Overnight Financing Percentage means that an applicable amount will be subtracted (debited) from your account balance.
                      <br><br>
                      You can find the relevant Overnight Financing percentage, amounts and their related running times on both the Deal and Limit forms, under Tools, within the ‘Market Info’ tab. To calculate the Overnight Financing, which your account will be debited or credited with, simply multiply the Overnight Financing percentage with the size of your deal. The running time of the Overnight Financing process for each CFD is detailed in the deal form's ‘Instrument Info Tool’ under "Overnight Financing (GMT)". The calculated value and percentage of an instrument's Overnight Financing applies for 1 day. CFDs that are traded 5 days a week will be credited or debited with a value 3 times the displayed value during the last day of its underlying asset trading week, as it covers the entire weekend period. The Overnight Financing amount is quoted according to the currency of the CFD. However, should the quoted CFD’s currency differ from the account currency, it will be converted to the account’s currency.
                      <br><br>
                      <u><b><u>Formula</u></b></u><br><br>
                      Calculation of Overnight Financing Percentage when you Buy (Long Positions):
                      <br>
  
                    <div class="formula formula_f1">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">3M interest rate of the other currency - 3M interest rate of the base currency + Long markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                    <br>
                      Calculation of Overnight Financing Percentage when you Sell (Short Positions):
                      <br><br>
                      
                      <div class="formula formula_f2">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">3M interest rate of the other currency - 3M interest rate of the base currency - Short markup</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      To calculate the Overnight Financing Amount, simply multiply the percentage by the deal amount:<br><br>Overnight Financing Amount = Deal Amount × Overnight Financing Percentage
                      <br><br><br>
                      <u><b><u>Examples</u></b></u><br><br>
                      <b>Example I</b><br><br>
                      This example involves a situation whereby the Interbank Rate difference is HIGHER than the markup. In such cases, your account will be debited when you go Long and credited when you go Short:
                      
                  </p>
  
                  <ul class="list-style-dashed mb-4">
                      <li>Instrument = EUR/USD (Euro vs. US Dollar)</li>
                      <li>EUR (base currency) 3M interest rate (annualized) = -0.37% = -0.0037</li>
                      <li>USD (other currency) 3M interest rate (annualized) = 1.08% = 0.0108</li>
                      <li>Interbank Rates difference = 1.45% = 0.0145</li>
                      <li>Long Markup = 0.75% = 0.0075</li>
                      <li>Short Markup = 0.75% = 0.0075</li>
                      <li>Deal Amount value expressed in the other currency = 106,550 USD (100,000 EUR at Current Closing Rate of 1.0655)</li>
                  </ul>
                  <p>
                      Overnight Financing Percentage when you Buy (Long Positions):<br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                      Overnight Financing Amount = 106,550 × (-0.0000611) = -6.51 USD, meaning 6.51 USD charge per day
                      
                      
                      <br><br><br>
                      Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                      Overnight Financing Amount = 106,550 × 0.00001944 = 2.07 USD credit per day
                      <br><br><br>
                      
                      <b>Example II</b><br><br>
                      
                      This example involves a situation whereby the Interbank Rate difference is HIGHER than the markup and the Long and Short markups are different. In such cases, your account will be debited each night regardless of your position’s direction:
                  </p>
                  
                  <ul class="list-style-dashed mb-4">
                      <li>Instrument = EUR/TRY (Euro vs. Turkish Lira)</li>
                      <li>EUR (base currency) 3M interest rate (annualized) = -0.37% = -0.0037</li>
                      <li>TRY (other currency) 3M interest rate (annualized) = 22.75% = 0.2275</li>
                      <li>Interbank Rates difference = 23.12% = 0.2312</li>
                      <li>Long Markup = 0.75% = 0.0075</li>
                      <li>Short Markup = 14.00% = 0.14</li>
                      <li>Deal Amount value expressed in the other currency = 620,000 TRY (100,000 EUR at Current Closing Rate of 6.2000)</li>
                  </ul>
                  
                  <p>
                      Overnight Financing Percentage when you Buy (Long Positions):<br>
                      
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                      Overnight Financing Amount = 620,000 × (-0.000663) = -411 TRY, meaning 411 TRY charge per day (≅80 USD)
                      <br><br><br>

                      Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                      Overnight Financing Amount = 620,000 × (0.000253) = 157 TRY, meaning 157 TRY credit per day (≅30 USD)
                      <br><br><br>
                      <b>Example III</b><br><br>
                      This example involves a situation whereby the Interbank Rate difference is LOWER than the negative markup. In such cases, your account will be debited when you go Short and credited when you go Long:
                  </p>
                  
                  <ul class="list-style-dashed mt-4 mb-4">
                      <li>Instrument = USD/JPY (US Dollar vs. Japanese Yen)</li>
                      <li>USD (base currency) 3M interest rate (annualized) = 1.08% = 1.08</li>
                      <li>JPY (other currency) 3M interest rate (annualized) = -0.09% = -0.0009</li>
                      <li>Interbank Rates difference = -1.17% = -0.0117</li>
                      <li>Long Markup = 0.75% = 0.0075</li>
                      <li>Short Markup = 0.75% = 0.0075</li>
                      <li>Deal Amount value expressed in the other currency = 10,341,000 JPY (100,000 USD at Current Closing Rate of 103.41)</li>
                  </ul>
                  
                  <p>
                      Overnight Financing Percentage when you Buy (Long Positions):<br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                      Overnight Financing Amount = 10,341,000 × 0.00001167 = 120.65 JPY credit per day (≅1.1 USD)
                      <br><br><br>

                      Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">Overnight Financing Percentage</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                      Overnight Financing Amount = 10,341,000 × (-0.0000533) = -551.52 JPY, meaning 551.52 JPY charge per day (≅5.3 USD)
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* Overnight Financing settlements may take up to 15 minutes to process at the end of the trading day, following which your account will be credited or debited appropriately.</p>`,
          table_titles: [
            "Instrument",
            "Daily Overnight Financing Percentage (Sell)",
            "Daily Overnight Financing Percentage (Buy)",
            "Overnight Financing (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "Index, Commodity and Crypto CFDs",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "Overnight Financing",
          content_before: `
              <p>
                  When trading Index, Commodity and Crypto CFDs with iFOREX Europe, your open deals are subject to Overnight Financing at the end of each trading day. This Overnight Financing may be subject to credit or debit, calculated on the basis of the relevant interest rates for the currencies in which the underlying instrument is traded, plus a mark-up. The mark-up for Cryptocurrencies can be significantly higher due to Cryptocurrencies’ extreme market conditions. Please review the below table for the latest Overnight Financing levels.
                  <br><br>
                  If the calculated Overnight Financing Percentage is positive, it means that an applicable amount will be added (credited) to your account balance. A negative Overnight Financing Percentage means that an applicable amount will be subtracted (debited) from your account balance.
                  <br><br>
                  You can find the relevant Overnight Financing percentage, amounts and their related running times on both the Deal and Limit forms, under Tools, within the ‘Market Info’ tab. To calculate the Overnight Financing, which your account will be debited or credited with, simply multiply the Overnight Financing Percentage with the size of your deal. The running time of the Overnight Financing process for each CFD is detailed in the deal form's ‘Instrument Info Tool’ under "Overnight Financing (GMT)". The calculated value and percentage of an instrument's Overnight Financing applies for 1 day. CFDs that are traded 5 days a week will be credited or debited with a value 3 times the displayed value during the last day of its underlying asset trading week, as it covers the entire weekend period. The Overnight Financing amount is quoted according to the currency of the CFD. However, should the quoted CFD’s currency differ from the account currency, it will be converted to the account’s currency.
                  <br><br>
                  <u><b><u>Formula</u></b></u><br><br>
                  Calculation of Overnight Financing Percentage when you Buy (Long Positions):<br>
                  
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">3M interest rate + markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                  Calculation of Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">3M interest rate - markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                  To calculate the Overnight Financing Amount, simply multiply the percentage by the deal amount:<br><br>Overnight Financing Amount = Deal Amount × Overnight Financing Percentage
                  <br><br><br>
                  <u><b><u>Examples</u></b></u><br><br>
                  <b>Example I</b><br><br>
                  This example involves a situation whereby the Interbank Rate is HIGHER than the markup. In such cases, your account will be debited when you go Long and credited when you go Short:
              </p>
  
              <ul class="list-style-dashed mb-4">
                  <li>Instrument = Brazil Ibovespa</li>
                  <li>Brazilian Real (BRL) 3M interest rate (annualized) = 9.567% = 0.09567</li>
                  <li>Markup = 2.5% = 0.025</li>
                  <li>Deal Amount value expressed in currency = 127,380 BRL (2 Index contracts at Current Closing Rate of 63690 BRL per contract)</li>
              </ul>
      
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):<br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                  Overnight Financing Amount = 127,380 × (-0.0003351944) = -42.70 BRL, meaning a 42.70 BRL charge per day (≅13.58 USD)
                  <br><br><br>
                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                  Overnight Financing Amount = 127,380 × 0.00019630556 = 25 BRL credit per day (≅7.95 USD)
                  <br><br><br>
                  <b>Example II</b><br><br>
                  This example involves a situation whereby the Interbank Rate is LOWER than the markup. In such cases your account will be debited each night regardless of the direction of your position:
              </p>
              
              <ul class="list-style-dashed mb-4">
                  <li>Instrument = Oil (Crude Light WTI)</li>
                  <li>US Dollar (USD) 3M interest rate (annualized) = 1.08% = 0.0108</li>
                  <li>Markup = 2.5% = 0.025</li>
                  <li>Deal Amount value expressed in currency = 53,250 USD (1,000 Oil barrels at Current Closing Rate of 53.25 USD per barrel)</li>
              </ul>
       
              
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):
                  
                  <br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                  Overnight Financing Amount = 53,250 × (-0.00009944) = -5.30 USD, meaning a 5.30 USD charge per day
                  <br><br><br>
                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">Overnight Financing Percentage</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                  Overnight Financing Amount = 53,250 × (-0.00003944) = -2.10 USD, meaning a 2.10 USD charge per day
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Overnight Financing settlements may take up to 15 minutes to process at the end of the trading day, following which your account will be credited or debited appropriately.</p>`,
          table_titles: [
            "Instrument",
            "Daily Overnight Financing Percentage (Sell)",
            "Daily Overnight Financing Percentage (Buy)",
            "Overnight Financing (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
        //id: "contracts_rollover_dates",
        id: "tc-view-3",
          title: "Contracts' Rollover Dates",
          content_before: `<p>
                      Every CFD that is based on future contract (i.e. commodities and indices) has a rollover date.
                      <br><br>
                      Upon reaching the relevant instrument’s rollover date, all open future contract CFD positions will be rolled-over to the next contract, so that the positions remain open with the new future contract.
                      <br><br>
                      Upon effectuating such rollover, the Position’s open P/L (Profit / Loss) will express the price difference between the expired and new contract prices, as well as include a mark-up spread. All the associated Limit Orders levels shall be automatically adjusted according to the new future contract price.
                      <br><br>
                      For example, if the last price of the WTI Oil February contract is $50.125 and the market price of the following contract (March) at that time is $50.805, then the price level of all the outstanding limit orders will be updated upwards by $0.68.
                      <br><br>
                      The rollover dates of contracts depend on the instrument you are trading, and those set out below shall be the sole rollover dates applicable to iFOREX Europe's CFD:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["Contract Month", "Contract Rollover (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["Commodities", "Indices"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "Share and ETF CFDs",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "Overnight Financing",
          content_before: `<p>
                  When trading Share and ETF CFDs with iFOREX Europe, your open deals are subject to Overnight Financing at the end of each trading day. This Overnight Financing may be subject to credit or debit, calculated on the basis of the relevant interest rates for the currencies in which the underlying instrument is traded, plus a mark-up. Please review the below table for the latest Overnight Financing levels.
                  <br><br>
                  If the calculated Overnight Financing Percentage is positive, it means that an applicable amount will be added (credited) to your account balance. A negative Overnight Financing Percentage means that an applicable amount will be subtracted (debited) from your account balance.
                  <br><br>
                  You can find the relevant Overnight Financing percentage, amounts and their related running times on both the Deal and Limit forms, under Tools, within the ‘Market Info’ tab. To calculate the Overnight Financing, which your account will be debited or credited with, simply multiply the Overnight Financing Percentage with the size of your deal. The running time of the Overnight Financing process for each CFD is detailed in the deal form's ‘Instrument Info Tool’ under "Overnight Financing (GMT)". The calculated value and percentage of an instrument's Overnight Financing applies for 1 day. CFDs that are traded 5 days a week will be credited or debited with a value 3 times the displayed value during the last day of its underlying asset trading week, as it covers the entire weekend period. The Overnight Financing amount is quoted according to the currency of the CFD. However, should the quoted CFD’s currency differ from the account currency, it will be converted to the account’s currency.
                  <br><br>
                  <u><b><u>Formula</u></b></u><br><br>
                  Calculation of Overnight Financing Percentage when you Buy (Long Positions):
                  
                  <br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">3M interest rate + markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                Calculation of Overnight Financing Percentage when you Sell (Short Positions):

                <br><br>

                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">3M interest rate - markup</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>


                  To calculate the Overnight Financing Amount, simply multiply the percentage by the deal amount:<br><br>Overnight Financing Amount = Deal Amount × Overnight Financing Percentage
                  <br><br><br>
                  <u><b><u>Examples</u></b></u><br><br>
                  <b>Example I</b><br><br>
                  This example involves a situation whereby the Interbank Rate is HIGHER than the markup. In such cases your account will be debited when you go Long and credited when you go Short:
              </p>
  
              <ul class="list-style-dashed mb-4">
                  <li>Instrument = Gazprom (GAZP)</li>
                  <li>Russian Ruble (RUB) 3M interest rate (annualized) = 9.5% = 0.095</li>
                  <li>Markup = 5% = 0.05</li>
                  <li>Deal Amount value expressed in currency = 2,459,000 RUB (20,000 Shares at Current Closing Rate of 122.95 RUB per share)</li>
              </ul>
              
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):<br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

              Overnight Financing Amount = 2,459,000 × (-0.0004) = -983.60 RUB, meaning a 983.60 RUB charge per day (≅17.52 USD)

                  <br><br><br>

                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                Overnight Financing Amount = 2,459,000 × 0.000125 = 307.38 RUB credit per day (≅5.48 USD)
                <br><br><br>

                  <b>Example II</b><br><br>
                  This example involves a situation whereby the Interbank Rate is LOWER than the markup. In such cases, your account will be debited each night regardless of your position’s direction:<br>
              </p>
  
              <ul class="list-style-dashed mb-2">
                  <li>Instrument = Apple (AAPL)</li>
                  <li>US Dollar (USD) 3M interest rate (annualized) = 1.08% = 0.0108</li>
                  <li>Markup = 5% = 0.05</li>
                  <li>Deal Amount value expressed in currency = 70,600 USD (500 Shares at Current Closing Rate of 141.20 USD per share)</li>
              </ul>
              <br>
  
              <p>
                  Overnight Financing Percentage when you Buy (Long Positions):<br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                  Overnight Financing Amount = 70,600 × (-0.000169) = -11.93 USD, meaning a 11.93 USD charge per day
                  <br><br><br>
                  Overnight Financing Percentage when you Sell (Short Positions):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">Overnight Financing Percentage</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                  Overnight Financing Amount = 70,600 × (-0.000109) = -7.70 USD, meaning a 7.70 USD charge per day
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* Overnight Financing settlements may take up to 15 minutes to process at the end of the trading day, following which your account will be credited or debited appropriately.</p>`,
          table_titles: [
            "Instrument",
            "Daily Overnight Financing Percentage (Sell)",
            "Daily Overnight Financing Percentage (Buy)",
            "Overnight Financing (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "Dividends",
          content_before: `<p>
                      In the event of a distribution of cash dividends in relation to a share CFD, a dividend adjustment will be made to the Client’s Balance with respect to the underlying share CFD positions held by the Client at the end of the business day preceding the ex-dividend date. The dividend adjustment shall be calculated based on the size of the dividend, the size of the Client’s position and whether it is a buy or a sell transaction. In long positions the adjustment shall be credited to the Client’s Balance and in short positions the adjustment shall be debited from the Client’s Balance. Dividends shall be credited or debited from the Client’s Balance outside of the underlying shares' trading hours and before the opening of the shares' next trading day and are contingent upon the Client holding their respective position at the time of the dividend adjustment. During this period, in order to keep the fair value of the Client’s Equity until the opening of the next trading day, the Company shall adjust the Client’s position in accordance with the dividend amount debited or credited from the Client’s Balance.
                      <br><br>
                      <u>Example:</u><br>
                      Coca-Cola issues a dividend of 0.35 USD per share. <br>
                      The Ex-Dividend date is November 29th and the settlement date in iFOREX Europe is November 28th at 22:05 GMT.<br>
                      The closing price before the settlement is 41.65.<br>
                      A client that holds a Long positon of 5000 shares will be credited with 0.35 x 5000 = 1750 USD if his deal is open at the settlement date.<br>
                      Similar amount will be charged from the balance of a client that holds a Short position.<br>
                      The share price will be adjusted during the afterhours from 41.65 to 41.30 which equals to the last share price minus the dividend amount.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"There's currently no information on future dividends",
          table_titles: [
            "Share / ETF",
            "Market",
            "Dividend Amount",
            "Date and Time (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "Stock Splits and other Corporate Actions",
          content_before: `<p>
              
          Corporate Actions are certain events that effect a public company's share value. Unless mentioned otherwise hereunder in respect of specific Corporate Actions, upon the occurrence of a Corporate Action in a specific share, iFOREX Europe shall liquidate any open position(s) of the relevant CFD(s) including, where required, the removal of any limit order(s) of such CFD(s).
          <br><br>
            Corporate Actions in iFOREX Europe include Rights Offering, Delisting and any other event which materially affects or may materially affect the shares’ price (including material company announcements, takeovers, mergers, insolvency etc.).
            <br><br>

            

            <b>Stock Splits and Reverse Stock Splits specific rules</b><br>
                Stock splits and reverse stock splits on-exchange do not alter the total value of stocks for those who hold them, but rather change the number of stocks and their price. These splits are usually implemented when the stock price is either too high or too low. Should an open deal/limit encounter a stock split, its amount, rate and associated limit(s) level will be adjusted accordingly (including the account’s balance, due to required PL adjustments, if applicable).
                <br><br>
                For example, in a 1:10 split, 1 stock becomes 10 stocks after the event and the price is divided by 10, leaving the overall value of shares unchanged. E.g., 1 stock priced at $1,000 will become 10 stocks priced at $100 after the event: 1x $1,000 = 10 x$100 = $1,000 value.
                <br><br>
                Please find below a list of the upcoming Corporate Actions:
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"There's currently no information on future Corporate Actions",
          table_titles: ["Share / ETF", "Market", "Type", "Date and Time (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "Earnings Reports",
          content_before: `<p>
                                  An earnings report is a periodic filing made by public companies to report their performance. By analyzing quarterly earnings reports, investors can analyze the financial health of the company. The announcement of earnings for a company, particularly for a popular company with a high market capitalization, can affect its share prices, which can cause it to fluctuate widely on days when such quarterly earnings reports are released.
                                  <br><br>
                                  For that reason, maximum exposure of the relevant shares will be lowered to $10,000 throughout the period of publication.
                              </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  